import { includes } from 'lodash';

import {
  PENDING,
  PROCESSING_PAYOUT,
  AUTHORIZING,
  AUTHORIZED,
  ACTIVE,
  PAID,
  CAPTURED,
} from './payment-statuses';

const isSent = (status) => isAuthorized(status) || isCaptured(status);

const isPaid = (status) => includes([PAID], status);

const isCaptured = (status) => includes([PROCESSING_PAYOUT, CAPTURED], status);

const isAuthorized = (status) => {
  return includes([AUTHORIZING, AUTHORIZED], status);
};

const isAuthorizing = (status) => {
  return includes([AUTHORIZING], status);
};

const isActive = (status) => {
  return includes([ACTIVE], status);
};

const isPending = (status) => {
  return includes([PENDING], status);
};

// Even though for the API 'processing' could mean only the payout processing wait time, for
// consumer verbiage it means that the organizer submitted the payment and is waiting for the
// merchant confirmation.
const isProcessing = (status) => {
  return includes([PROCESSING_PAYOUT, AUTHORIZING, AUTHORIZED], status);
};

export default {
  isPending,
  isActive,
  isCaptured,
  isPaid,
  isSent,
  isAuthorized,
  isProcessing,
  isAuthorizing,
};



// WEBPACK FOOTER //
// ./src/lib/payment.js